<div *ngIf="showFlag" class="overlay">
    <div *ngIf="spinnerType === 'tpulse'" class="tpulse-container">
      <img src="assets/gif/t-pulse.gif" height="300" alt="T-PULSE">
    </div>
    <div *ngIf="spinnerType === 'default'" class="default-container">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
        width="100" height="100" viewBox="25 25 50 50">
        <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#006699" stroke-width="2" />
      </svg>
    </div>
    <div *ngIf="spinnerType === 'drone'" class="drone-container">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
        width="200" height="80" viewBox="160 200 480 140" enable-background="new -102.833 -102.889 341.333 300.667"
        xml:space="preserve">
        <g>
          <path stroke="white" fill="white"
            d="M577.6,233.28c0-1.44-1.439-2.88-2.88-2.88c-1.439,0-2.88,1.44-2.88,2.88v3.36h5.76V233.28z"></path>
          <path stroke="white" fill="white"
            d="M578.08,271.2v-15.84c-0.96,0-1.44,0-2.4,0s-2.399,0-3.359,0v15.36c-2.4-0.48-3.84-0.48-3.84-0.48H463.84   l-11.52-20.64c-0.96-1.44-3.36-2.88-5.28-2.88h-28.32c-5.279-4.8-11.52-8.16-18.72-8.16s-13.92,3.36-18.72,8.16h-28.32   c-1.92,0-4.32,1.44-5.28,2.88l-11.52,20.64H232c0,0-1.44,0-3.84,0.48v-15.36c-1.44,0-2.4,0-3.84,0c-0.48,0-1.44,0-2.4,0v16.32   c-7.68,1.44-16.8,4.32-16.8,10.08c0,10.08,6.24,27.84,15.36,27.84s11.04-4.8,11.04-4.8l11.04-25.92c0,0,49.44,0,108.96,0   l8.16,23.521c-7.2,7.68-15.84,19.68-15.84,31.68c0,22.08,3.84,28.8,3.84,28.8s3.84,9.601,4.32-1.439s-3.36-10.561-3.36-28.32   c0-9.12,7.2-19.2,13.92-26.88h74.4c6.72,7.68,13.92,17.76,13.92,26.88c0,17.28-3.84,16.8-3.359,28.32   c0.479,11.52,4.319,1.439,4.319,1.439s3.84-6.72,3.84-28.8c0-12-8.159-23.521-15.84-31.68L448,278.88c59.521,0,108.96,0,108.96,0   L568,304.8c0,0,1.44,4.8,11.04,4.8c9.601,0,15.36-18.24,15.36-27.84C594.4,275.52,585.28,272.64,578.08,271.2z">
          </path>
          <path stroke="white" fill="white"
            d="M228.16,233.28c0-1.44-1.44-2.88-2.88-2.88c-1.44,0-2.88,1.44-2.88,2.88v2.88h5.76V233.28z"></path>
        </g>
      </svg>
      <svg class="blade bladeLeft" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="8" width="75" viewBox="0 0 75 8"
        enable-background="new 0 0 75 8" xml:space="preserve">
        <rect height="8px" stroke="white" fill="white" width="75px" ry="8px"></rect>
      </svg>
      <svg class="blade bladeRight" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="8" width="75" viewBox="0 0 75 8"
        enable-background="new 0 0 75 8" xml:space="preserve">
        <rect height="8px" stroke="white" fill="white" width="75px" ry="8px"></rect>
      </svg>
    </div>
    <div *ngIf="spinnerType === 'cctv'" class="cctv-container">
      <img src="assets/gif/cctv.gif" height="125" alt="CCTV">
      <!-- <svg class="cctv" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
              viewBox="-5 -28 421.931 401.931" xml:space="preserve">
              <g>
                  <g>
                      <path d="M395.928,187.794l-272.1-135.687c-5.358-2.669-11.866-0.494-14.538,4.864L51.24,173.379
              c-1.283,2.573-1.491,5.55-0.579,8.276c0.912,2.727,2.869,4.979,5.443,6.262l81.242,40.511l-7.208,14.455
              c-2.671,5.358-0.494,11.866,4.864,14.538l2.561,1.278l-13.998,24.929H41.027C33.351,268.782,17.867,258.626,0,258.626v92.338
              c17.454,0,32.642-9.688,40.49-23.978h95.766c7.838,0,15.065-4.229,18.903-11.063l21.255-37.85l3.695,1.842
              c5.357,2.671,11.867,0.493,14.539-4.863l7.208-14.455l60.7,30.271c3.501,1.746,7.671,1.471,10.911-0.723l16.753-11.332
              l29.912,14.916c1.518,0.758,3.174,1.14,4.837,1.14c1.159,0,2.32-0.188,3.439-0.562c2.727-0.91,4.979-2.869,6.262-5.441
              l30.624-61.413l31.757-20.903c3.239-2.132,5.092-5.832,4.86-9.702C401.679,192.976,399.397,189.525,395.928,187.794z" />
                  </g>
              </g>
          </svg> -->
    </div>
  </div>
  